var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { GraphQLClient } from 'graphql-request';
import { getSdk } from '../common/__generated__/api';
/* eslint-disable no-undef */
// We want to eventually load this from config with the current git hash and environment
var CLIENT_INFO = 'lx-nimble,unknown,unknown';
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export var getBexApiSdk = function (headers, url) {
  if (url === void 0) {
    url = '/graphql';
  }
  var sdkHeaders = __assign(__assign({}, headers), {
    'Client-Info': CLIENT_INFO
  });
  var options = {
    headers: new Headers(sdkHeaders),
    credentials: 'same-origin',
    cache: 'no-cache'
  };
  var client = new GraphQLClient(url, options);
  return getSdk(client);
};